import React from 'react'
import {Icon} from '@chakra-ui/react'

const SearchIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="search" {...props}>
            <path
                d="M16.4311 31.9001C7.92349 31.9001 1 24.9681 1 16.45C1 7.93199 7.92349 1 16.4311 1C24.9387 1 31.8622 7.93199 31.8622 16.45C31.8622 24.9681 24.9387 31.9001 16.4311 31.9001ZM16.4311 2.86595C8.9485 2.86595 2.86366 8.95826 2.86366 16.45C2.86366 23.9418 8.9485 30.0341 16.4311 30.0341C23.9137 30.0341 29.9985 23.9418 29.9985 16.45C29.9985 8.95826 23.9137 2.86595 16.4311 2.86595Z"
                fill="currentColor"
            />
            <path
                d="M38.0681 39C37.8351 39 37.5929 38.9067 37.4158 38.7294L26.0382 27.4311C25.6748 27.0673 25.6748 26.4795 26.0382 26.1156C26.4016 25.7518 26.9887 25.7518 27.3521 26.1156L38.7297 37.4139C39.0931 37.7778 39.0931 38.3656 38.7297 38.7294C38.5433 38.916 38.3104 39.0093 38.0681 39.0093V39Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SearchIcon
